/* SPACES: loading animation over the preview while the AI generates an image.
   Wraps the generation request (POST to the AI endpoint) and shows an overlay on the preview stage until it finishes. */
(function () {
  var root = document.querySelector('.sp-dz[data-ai]');
  var ep = root ? (root.dataset.ai || '').replace(/\/+$/, '') : '';
  if (!root || !ep) return;
  var lg = (document.documentElement.lang || 'hu').slice(0, 2);
  var M = {
    hu: { t: 'Elkészítjük a képedet', n: 'Ez általában 20–30 másodperc.', m: ['Ötleteket gyűjtünk…', 'Felvázoljuk a kompozíciót…', 'Színeket keverünk…', 'Finomítjuk a részleteket…', 'Mindjárt kész…'] },
    en: { t: 'Creating your image', n: 'This usually takes 20–30 seconds.', m: ['Gathering ideas…', 'Sketching the composition…', 'Mixing the colours…', 'Refining the details…', 'Almost there…'] },
    ro: { t: 'Creăm imaginea ta', n: 'Durează de obicei 20–30 de secunde.', m: ['Adunăm idei…', 'Schițăm compoziția…', 'Amestecăm culorile…', 'Rafinăm detaliile…', 'Aproape gata…'] }
  };
  var T = M[lg] || M.hu;
  var last = null;
  document.addEventListener('submit', function (e) { last = e.target; }, true);

  function show(form) {
    var panel = form && form.closest ? form.closest('.dz-panel') : null;
    var stage = panel && (panel.querySelector('.sp-dz-stage') || panel.querySelector('.sp-wprev'));
    if (!stage) return null;
    if (getComputedStyle(stage).position === 'static') stage.style.position = 'relative';
    var ov = document.createElement('div');
    ov.className = 'sp-gen';
    ov.setAttribute('role', 'status'); ov.setAttribute('aria-live', 'polite');
    ov.innerHTML = '<div class="in"><div class="orb" aria-hidden="true"><i></i><i></i><i></i></div><b>' + T.t + '</b><p class="msg">' + T.m[0] + '</p><div class="bar" aria-hidden="true"><u></u></div><small>' + T.n + '</small></div>';
    stage.appendChild(ov);
    var t0 = Date.now(), k = 0, msg = ov.querySelector('.msg'), bar = ov.querySelector('.bar u');
    ov.__t = setInterval(function () {
      var s = (Date.now() - t0) / 1000;
      bar.style.width = (92 * (1 - Math.exp(-s / 14))).toFixed(1) + '%';
      var i = Math.min(T.m.length - 1, Math.floor(s / 6));
      if (i !== k) { k = i; msg.textContent = T.m[i]; }
    }, 250);
    requestAnimationFrame(function () { ov.classList.add('on'); });
    return ov;
  }
  function hide(ov) {
    if (!ov) return;
    clearInterval(ov.__t);
    var bar = ov.querySelector('.bar u'); if (bar) bar.style.width = '100%';
    setTimeout(function () { ov.classList.remove('on'); setTimeout(function () { if (ov.parentNode) ov.parentNode.removeChild(ov); }, 400); }, 350);
  }

  var of = window.fetch;
  window.fetch = function (input, init) {
    var p = of.call(this, input, init), u = typeof input === 'string' ? input : input && input.url;
    if (u && u.replace(/\/+$/, '') === ep && init && init.method === 'POST' && typeof init.body === 'string' && init.body.indexOf('"prompt"') > -1) {
      var ov = show(last), done = function () { hide(ov); };
      p.then(done, done);
    }
    return p;
  };
})();
